import Vue from 'vue';
import VueStripeCheckout from 'vue-stripe-checkout';

Vue.use(VueStripeCheckout, 'pk_test_kxHCASGIJBvHF8Mo5Rtb43ib');
